import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { createPendingRegistrationContainer } from '../../container/pending-registration-module'
import styles from './Registration.module.css'

type Props = {
  token: string
  userData: {
    firstName: string
    lastName: string
    email: string
  } | null
  onSuccess?: () => void
  onBack: () => void
}

export function EmailRegistrationForm({ token, userData, onSuccess, onBack }: Props) {
  const { t } = useTranslation()
  const [email, setEmail] = useState(userData?.email || '')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const container = createPendingRegistrationContainer()

  const validateForm = () => {
    if (!email || !password || !confirmPassword) {
      setError(t('requiredFields'))
      return false
    }

    if (password !== confirmPassword) {
      setError(t('passNotEquals'))
      return false
    }

    if (password.length < 6) {
      setError(t('passwordLength'))
      return false
    }

    return true
  }

  const handleRegister = async () => {
    setError(null)
    if (!validateForm()) return

    setLoading(true)
    try {
      await container.pendingRegistrationService
        .completeRegistration({
          token,
          email,
          password,
        })
        .toPromise()

      setSuccess(t('registrationSuccess'))

      if (onSuccess) {
        onSuccess()
      }

      setTimeout(() => {
        window.location.href = '/'
      }, 2000)
    } catch (e: any) {
      setError(e.message || t('registrationError'))
    }
    setLoading(false)
  }

  return (
    <div className={styles.containerForm}>
      <div className={styles.registrationFormContainer}>
        <h4 className={styles.registrationTitle}>{t('completeRegistration')}</h4>
        <hr className={styles.divider} />

        {userData && (
          <div className={styles.userInfoAlert}>
            {t('welcome')} {userData.firstName} {userData.lastName}
          </div>
        )}

        <div className={styles.formField}>
          <label className={styles.inputTitle}>{t('email')}</label>
          <input
            type="email"
            className={styles.formInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className={styles.passwordField}>
          <label className={styles.inputTitle}>{t('password')}</label>
          <input
            type="password"
            className={styles.formInput}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className={styles.passwordField}>
          <label className={styles.inputTitle}>{t('confirmPassword')}</label>
          <input
            type="password"
            className={styles.formInput}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        {error && <div className={styles.errorAlert}>{error}</div>}

        {success && <div className={styles.successAlert}>{success}</div>}

        <div className={styles.buttonContainer}>
          <button className={styles.backButton} onClick={onBack}>
            {t('back')}
          </button>
          <button className={styles.submitButton} onClick={handleRegister} disabled={loading}>
            {loading ? t('processing') : t('completeRegistration')}
          </button>
        </div>
      </div>
    </div>
  )
}
